package com.eladfinish.bible.contest.screens.browse.tableOfContents.ui.dialogs

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.font.FontWeight
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.browseGuide_txt
import com.eladfinish.bible.contest.constants.ColorConstants
import com.eladfinish.bible.contest.extensions.end
import com.eladfinish.bible.contest.extensions.start
import com.eladfinish.bible.contest.help
import com.eladfinish.bible.contest.screens.browse.tableOfContents.BrowseTabsAction
import com.eladfinish.bible.contest.screens.browse.tableOfContents.BrowseTabsAction.ToggleHelp
import com.eladfinish.bible.contest.screens.browse.tableOfContents.BrowseTabsAction.UpdateFontSize
import com.eladfinish.bible.contest.screens.browse.tableOfContents.BrowseTabsState
import com.eladfinish.bible.contest.ui.components.dialogs.GeneralHelpDialog
import com.eladfinish.bible.contest.ui.components.dialogs.HelpContentType.Asset

@Composable
internal fun BrowseDialogs(
    dialogState: BrowseTabsState.DialogState,
    onAction: (BrowseTabsAction) -> Unit,
) {
    when (dialogState) {
        BrowseTabsState.DialogState.None -> Unit

        is BrowseTabsState.DialogState.Help -> {
            GeneralHelpDialog(
                titleResource = SharedRes.strings.help,
                helpContentType = Asset(SharedRes.assets.other.browseGuide_txt),
                spanStyles = { text ->
                    listOfNotNull(
                        "שחור".colorWord(text = text, color = Color.Black),
                        "ירוק".colorWord(text = text, color = ColorConstants.GREEN2),
                        "אדום".colorWord(text = text, color = ColorConstants.RED2),
                    )
                },
                isDontShowAgainChecked = dialogState.isDontShowAgainChecked,
                onApproveDialog = {
                    onAction(ToggleHelp(shouldShowNextTime = it))
                },
                onDismiss = {
                    onAction(BrowseTabsAction.HideDialog)
                },
            )
        }

        is BrowseTabsState.DialogState.FontSize -> {
            FontSizeDialog(
                initialFontSizeSp = dialogState.currentFontSize,
                onConfirm = { value ->
                    onAction(UpdateFontSize(value = value))
                    onAction(BrowseTabsAction.HideDialog)
                },
                onDismiss = {
                    onAction(BrowseTabsAction.HideDialog)
                },
            )
        }

        is BrowseTabsState.DialogState.SavedCompletions -> {
            LoadChapterCompletionDialog(
                state = dialogState,
                onAction = onAction,
            )
        }

        is BrowseTabsState.DialogState.RemoteSavedCompletions -> {
            LoadRemoteChapterCompletionDialog(
                state = dialogState,
                onAction = onAction,
            )
        }
    }
}

//נועד לצבוע את המילה ירוק בצבע ירוק וכדו׳
private fun String.colorWord(
    text: String,
    color: Color,
): AnnotatedString.Range<SpanStyle>? =
    this.toRegex().find(input = text)?.let {
        AnnotatedString.Range(
            item = SpanStyle(
                color = color,
                fontWeight = FontWeight.Bold,
            ),
            start = it.start,
            end = it.end,
        )
    }
